<!-- 选择角色 -->
<template>
  <el-form-item :label="label">
    <el-select
      v-model="roleIds"
      placeholder="请选择"
      :multiple="config.multiple"
      collapse-tags
      collapse-tags-tooltip
      clearable
    >
      <el-option
        v-for="item in store.roles.value"
        :key="item.id"
        :label="item.roleName"
        :value="item.id"
      ></el-option>
    </el-select>
  </el-form-item>
</template>

<script>
import { inject } from 'vue';

export default {
  kind: 'yq-角色选择',
  props: {
    // 初始值.
    value: {
      type: [Array, String, Number],
      default: () => [],
    },
    label: {
      type: String,
      default: '选择角色：',
    },
    config: {
      type: Object,
      default() {
        return {
          multiple: true,
        };
      },
    },
  },
  setup(props) {
    const useQuery = inject('useQuery');
    const roleIds = useQuery('role', props.value);
    return {
      roleIds,
    };
  },
};
</script>
